module.exports = __webpack_public_path__ + "static/media/my_image.af43a129.png";